// Lib
import React, { ReactElement } from 'react';
import classNames from 'classnames';

// Components
import Icon from '../../../../../../../components/icons/Icon';
import Button, { ButtonProps } from '../../../../../../../components/buttons/Button';

// Styles
import './AiListButton.scss';

export enum AiListButtonTypes {
    ADVANCE,
    SUBMIT,
    AUTO_GENERATE,
    REFRESH,
}

interface AiListButtonProps extends ButtonProps {
    buttonType: AiListButtonTypes;
    active?: boolean;
}

const getButtonIconName = (buttonType: AiListButtonTypes) => {
    switch (buttonType) {
        case AiListButtonTypes.REFRESH:
            return 'ai-refresh';
        case AiListButtonTypes.AUTO_GENERATE:
            return 'ai-auto';
        case AiListButtonTypes.SUBMIT:
            return null;
        default:
            return null;
    }
};

const AiListButton = (props: AiListButtonProps): ReactElement => {
    const { buttonType = AiListButtonTypes.ADVANCE, active, children } = props;

    const iconName = getButtonIconName(buttonType);

    return (
        <Button {...props} className={classNames('AiListButton', { active })}>
            {children}
            {iconName && <Icon name={iconName} />}
        </Button>
    );
};

export default AiListButton;
